import { render, staticRenderFns } from "./GraphQLResource.vue?vue&type=template&id=38afad27&scoped=true&"
import script from "./GraphQLResource.vue?vue&type=script&lang=js&"
export * from "./GraphQLResource.vue?vue&type=script&lang=js&"
import style0 from "./GraphQLResource.vue?vue&type=style&index=0&id=38afad27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38afad27",
  null
  
)

export default component.exports